<template>
  <div class="wrapper">
    <div
      class="section page-header header-filter"
      :style="headerStyle"
    >
      <div class="container">
        <div class="md-layout">
          <div
            class="md-layout-item md-small-size-66 md-xsmall-size-80 md-medium-size-40 md-size-40 mx-auto"
          >
            <form @submit.prevent="login">
              <login-card header-color="primary">
                <h4
                  slot="title"
                  class="card-title"
                >
                  Login
                </h4>
                <p
                  slot="description"
                  class="description"
                >
                  Select your Grade and associated ID number as username
                </p>
                <md-field
                  slot="inputs"
                  class="md-layout"
                >
                  <md-icon>account_circle</md-icon>
                  <label>Username</label>
                  <md-select
                      id="grade"
                      v-model="grade"
                      name="grade"
                      class="md-layout-item md-size-30"
                  >
                    <md-option value="ae">
                        AE
                    </md-option>
                    <md-option value="aae">
                        AAE
                    </md-option>
                    <md-option value="at">
                        AT
                    </md-option>
                    <md-option value="aet">
                        AET
                    </md-option>
                    <md-option value="aat">
                        AAT
                    </md-option>
                    <md-option value="aaet">
                        AAET
                    </md-option>
                  </md-select>
                  <md-input v-model="gradeId" />
                </md-field>
                <md-field
                  slot="inputs"
                  class="md-layout"
                >
                  <md-icon>lock_outline</md-icon>
                  <label>Password</label>
                  <md-input class="md-layout-item" type="password" v-model="password" />
                </md-field>
                <div slot="inputs" class="text-center" v-if="error">
                  <div class="alert alert-danger">
                    <md-icon style="margin-right: 0.4em;">info_outline</md-icon>
                    <b>&nbsp;&nbsp;{{ error }}</b>
                  </div>
                </div>
                <md-button
                  slot="footer"
                  class="md-simple"
                  @click="$router.push('forgot-password')"
                  >Forgot my password
                </md-button>
                <md-button
                  slot="footer"
                  class="md-primary md-lg"
                  type="submit"
                >
                  Log In
                </md-button>
              </login-card>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LoginCard } from "@/components";
import Mixins from "@/plugins/basicMixins";

export default {
  components: {
      LoginCard
  },
  mixins: [Mixins.HeaderImage],
  bodyClass: "login",
  data: () => ({
    image: require("@/assets/img/hero3.jpg"),
    grade: "ae",
    gradeId: null,
    password: null,
    error: false
  }),
  methods: {
    async login() {
      const user = {
        data: {
          type: "token",
          attributes: {
            grade: this.grade,
            gradeId: this.gradeId,
            password: this.password,
          },
        },
      };

      const requestOptions = {
        headers: {
          Accept: "application/vnd.api+json",
          "Content-Type": "application/vnd.api+json",
        },
      };
      try {
        await this.$store.dispatch("login", { user, requestOptions });
      } catch (e) {
        this.error = "Wrong Username / Password";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.alert-danger .alert-icon .md-icon.md-theme-default.md-icon-font {
  color: #fff;
}
</style>
